module.exports = __webpack_public_path__ + "static/media/Group.00dd7ace.jpg";